import { lazy } from 'react';
import { Route, Routes } from 'react-router-dom';

const HomePage = lazy(() => import('../features/home/HomePage'));
const ArtisanPage = lazy(
  () => import('../features/hire-artisan/HireArtisanPage')
);
const HowItWorksPage = lazy(
  () => import('../features/handprenuer-flow/components/How-it-worksPage')
);
const SearchPage = lazy(() => import('../features/search/SearchPage'));
const CraftDetailPage = lazy(
  () => import('../features/card-details/CraftDetailPage')
);
const CategoriesPage = lazy(
  () => import('../features/craft-category/CraftsPage')
);
const AboutUs = lazy(() => import('../layout/footer/footer-pages/AboutUs'));
const Pricing = lazy(() => import('../layout/footer/footer-pages/Pricing'));
const Contact = lazy(() => import('../layout/footer/footer-pages/Contact'));
const FAQ = lazy(() => import('../layout/footer/footer-pages/FAQ'));
const Privacy = lazy(() => import('../layout/footer/footer-pages/Privacy'));
const Resources = lazy(() => import('../layout/footer/footer-pages/Resources'));
const Communities = lazy(
  () => import('../layout/footer/footer-pages/Communities')
);
const Terms = lazy(() => import('../layout/footer/footer-pages/Terms'));
const ResetPasswordPage = lazy(
  () => import('../features/auth/components/ResetPasswordPage')
);
const VerifyEmailPage = lazy(
  () => import('../features/auth/components/VerifyEmailPage')
);

export default function PublicRoutes() {
  return (
    <>
      <Route path="/" element={<HomePage />} />
      <Route path="/artisans" element={<ArtisanPage />} />
      <Route path="/how-it-works" element={<HowItWorksPage />} />
      <Route path="/search" element={<SearchPage />} />
      <Route path="/craft/:id" element={<CraftDetailPage />} />
      <Route path="/categories" element={<CategoriesPage />} />
      <Route path="/about" element={<AboutUs />} />
      <Route path="/pricing" element={<Pricing />} />
      <Route path="/contact" element={<Contact />} />
      <Route path="/faq" element={<FAQ />} />
      <Route path="/privacy" element={<Privacy />} />
      <Route path="/resources" element={<Resources />} />
      <Route path="/community" element={<Communities />} />
      <Route path="/terms" element={<Terms />} />
      <Route path="/reset-password/:token" element={<ResetPasswordPage />} />
      <Route path="/verify-email/:token" element={<VerifyEmailPage />} />
    </>
  );
}
